var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",modifiers:{"hover":true,"top":true}}],staticClass:"info_bullet",attrs:{"title":_vm.text}},[_vm._v("i")])}
var staticRenderFns = []

export { render, staticRenderFns }